import React from "react";
import PropTypes from "prop-types";
import { TextInput } from "../TextInput";
import TextFilterIcon from "./text-filter-icon.svg";

function textMatches(text, searchValue) {
    return text?.toLowerCase().includes(searchValue.trim().toLowerCase());
}

export function TextFilter({ value = null, className = "", onChange }) {
    // TODO: Throttle
    // update URL
    const onInputChange = (e) => {
        const searchVal = e.target.value;
        const filterFn = (itemProperty = "") => {
            return Array.isArray(itemProperty)
                ? itemProperty.some((val) => textMatches(val, searchVal))
                : textMatches(itemProperty, searchVal);
        };
        onChange(searchVal, searchVal && filterFn);
    };

    return (
        <div className={`text-filter ${className}`}>
            <TextInput
                className="text-filter__input"
                value={value ?? ""}
                aria-label="Search"
                placeholder="Search this page..."
                onChange={onInputChange}
            />
            <style jsx>{`
                .text-filter :global(.text-filter__input) {
                    background-image: url(${TextFilterIcon});
                    background-repeat: no-repeat;
                    background-size: 1.25em;
                    background-position: right 1.25em center;
                    padding-right: 3em;
                    width: 100%;
                }
            `}</style>
        </div>
    );
}

TextFilter.propTypes = {
    className: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};
TextFilter.defaultProps = {
    className: "",
};
